window._ = require('lodash');
window.CLASS_IS_ACTIVE = 'is-active';
window.CLASS_IS_FIX = 'fix';
try {
    window.$ = window.jQuery = require('jquery');
    require('jquery-datetimepicker');
} catch (e) {
    
}
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
